/* eslint-disable react/destructuring-assignment, react/jsx-props-no-spreading */
import React from 'react';

import {
    commonDefaultProps,
    commonPropTypes,
    concatClassNames,
    ypUtilsToClassNames,
    filterProps,
} from '../Abstrap/Abstrap';

const propTypes = {
    ...commonPropTypes,
};

const defaultProps = {
    ...commonDefaultProps,
};

const Pagination = (props) => {
    const classNames = [
        'c-pagination',
        props.className,
        ...ypUtilsToClassNames(props.ypUtils),
    ];
    return (
        <props.componentClass
            className={concatClassNames(classNames)}
            {...filterProps(propTypes, props)}
        >
            {props.children}
        </props.componentClass>
    );
};

Pagination.propTypes = propTypes;

Pagination.defaultProps = defaultProps;

export default Pagination;
